export enum TipoCuentaBancaria {
  CuentaCorriente = 1,
  CajaAhorro = 2,
}

export enum TipoMonedaDisplay {
  USD = "Dólares",
  ARS = "Pesos",
}

export enum TipoMoneda {
  USD = "USD",
  ARS = "ARS",
}

export enum TipoFijacion {
  Manual = "Manual",
  Automatica = "Automatica",
}

export enum CondicionFinanciera {
  Activa = 0,
  InactivaTotal = 1,
  InactivaParaPagos = 2,
}

export enum BeneficiaryAccountTypes {
  external = "External",
  internal = "Internal",
}

export enum BeneficiaryAccountTypesLabel {
  external = "Externa",
  internal = "Interna",
}

export enum TransferTransactionTypeEnum {
  AUTO = "Automatica",
  MANUAL = "Manual",
}

export enum RequestTypes {
  Efectivo = 1,
  Cheque = 2,
  ECheq = 3,
  Transferencia = 4,
  TransferenciaProgramada = 5,
  OrdenDeVenta = 6,
  ContraEntrega = 7,
  ContratoFuturo = 8,
  Cupos = 9,
  TransferenciaDiferida = 10,
  ChequeRespaldo = 11,
  CuposFertilizante = 12,
  CuposCombustible = 13,

  IntencionCompra = 16
}

export enum EntityTypes {
  SolicitudContacto = 1,
  Solicitudes = 2,
  ChequesRespaldo = 3,
  SolicitudInsumos = 4,
  PedidosInsumos = 5,
  SolicitudEfectivo = 6,
  SolicitudCheque = 7,
  SolicitudECheq = 8,
  Transferencia = 9,
  TransferenciaProgramada = 10,
  OrdenVenta = 11,
  ContraEntrega = 12,
  ContratoFuturo = 13,
  Cupos = 14,
  TransferenciaDiferida = 15,
  OBJuridico = 16,
  Archivo = 17,

  IntencionCompra = 21
}

export enum MaintenanceModules {
  General = "GENERAL",
  Granaria = "GRANARY",
  Finanzas = "FINANCIAL",
  MercadoDelDia = "DAILY_MARKET",
  Otros = "OTHER",
  Insumos = "SUPPLIES",
  Onboarding = "ONBOARDING"
}

export enum MaintenanceSections {
  GeneralApp = "GENERAL_APP",
  General = "GENERAL",

  // Granaria
  Slots = "SLOTS",
  SellOrder = "SELL_ORDER",
  Sales = "SALES",
  CashOnDelivery = "CASH_ON_DELIVERY",
  FutureContracts = "FUTURE_CONTRACTS",

  // Finanzas
  Cash = "CASH",
  Check = "CHECK",
  Transfer = "TRANSFER",
  FinancialMovements = "FINANCIAL_MOVEMENTS",

  // Cotizaciones
  PriceBoard = "PRICE_BOARD",
  UnionMarket = "UNION_MARKET",

  // Insumos en proceso

  // Otros
  UserProfile = "USER_PROFILE",
  Notifications = "NOTIFICATIONS",
  Sidebar = "SIDEBAR",

  //Onboarding
  JuridicOnboarding = "JURIDIC_ONB"
}

export enum TipoInsumos {
  Fertilizante = 1,
  Combustible = 2,
  Agroquimicos = 3,
  Semillas = 4
}

export enum LegalOnboardingStatusIds {
  Precargado = 195,
  Pendiente = 196,
  EnRevision = 197,
  RequiereCambios = 198,
  Aprobado = 199,
}

export enum LegalOnboardingDocumentStatusIds {
  Aceptado = 200,
  Rechazado = 201,
  PendienteDeAceptacion = 205,
  PEndienteDeSubida = 206 
}

export enum MeasurementUnits {
  Toneladas = 1,
  Litros = 2,
}

export const MeasurementUnitsLabel: Record<MeasurementUnits, string> = {
  [MeasurementUnits.Toneladas]: "Toneladas",
  [MeasurementUnits.Litros]: "Litros",
};

export enum ModuleTypes {
  Fertilizante =  1,
  Combustible = 2,
  Grano = 3
}

export const ModuleTypesLabel: Record<ModuleTypes, string> = {
  [ModuleTypes.Fertilizante]: "Fertilizante",
  [ModuleTypes.Combustible]: "Combustible",
  [ModuleTypes.Grano]: "Grano",
}

export enum MotiveTypes {
  RequiereInformacion = 1,
  Rechazo = 2,
  PedidoNoEntregado = 3,
}